import { defineStore } from "pinia"

function initState() {
    return {
        listingDetail: null,
        payment: null,
        pricePerMonth: 0,
        agentInfo: null,
        showCoAgent: false,
        tourBtnList: [],
        shares: null,
        triggerReadMore: false,
        openReadMore: false
    };
}

export default (storeName) => defineStore(storeName, {
    state: initState,
    getters: {},
    actions: {
        updateListingDetail(detail) {
            this.listingDetail = detail;
        },
        updatePayment(payment) {
            this.payment = payment;
        },
        updatePerMonth(pricePerMonth) {
            this.pricePerMonth = pricePerMonth;
        },
        updateAgentInfo(agentInfo) {
            this.agentInfo = agentInfo;
        },
        updateShowCoAgent(showCoAgent) {
            this.showCoAgent = showCoAgent;
        },
        updateTourBtn(list) {
            this.tourBtnList = list;
        },
        updateShare(shares) {
            this.shares = shares;
        },
        upTriggerReadMore(triggerReadMore) {
            this.triggerReadMore = triggerReadMore;
        },
        updateOpenReadMore(openReadMore) {
            this.openReadMore = openReadMore;
        },
        toggleOpenReadMore(state) {
            this.openReadMore = !this.openReadMore;
        }
    }
});
